import { TimeLine } from 'glamor';

export interface ICurvePoint {
	percent: number;
	GetValue: (value: number) => number;
}

export class Curve {
	constructor(readonly name: string, readonly points: ICurvePoint[], readonly keyFrames: TimeLine = {}) {}

	GetKeyframes(property: string, value: number, transformer: (value: number) => string) {
		this.points.forEach((point) => {
			let style: { [x: string]: string | number } = {};
			const pointValue = point.GetValue(value);
			style[property] = transformer(pointValue);
			this.keyFrames[`${point.percent}%`] = style;
		});

		return this.keyFrames;
	}
}

export const Curves = {
	Ease: () =>
		new Curve(`ease`, [
			{ percent: 0, GetValue: (value: number) => 0 },
			{ percent: 100, GetValue: (value: number) => value }
		]),
	Jump: () =>
		new Curve(`jump`, [
			{ percent: 0, GetValue: (value: number) => 0 },
			{ percent: 4, GetValue: (value: number) => 0.05 * value },
			{ percent: 40, GetValue: (value: number) => -0.1 * value },
			{ percent: 100, GetValue: (value: number) => value }
		]),

	Flash: () =>
		new Curve(`flash`, [
			{ percent: 0, GetValue: (value: number) => 0 },
			{ percent: 50, GetValue: (value: number) => 0.1 * value },
			{ percent: 80, GetValue: (value: number) => 0.2 * value },
			{ percent: 100, GetValue: (value: number) => value }
		])
};
